import { formatPhone, formatPhoneLink } from '../../../Utility/phoneNumberFormat';
import Logo from '../../../assets/HPSLOGO2022.png';
import { makeCall } from '../../../Utility/makeCallText';
import { sendEmail } from '../../../Utility/sendEmail';
import { openMap } from '../../../Utility/openMap';
// import { locationShare } from './LocationShare';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../../../firebase';
import { useLocation } from 'react-router-dom';
import { Location } from '../../../Types/Location';
import { IosShare, NearMe, PermPhoneMsg, Schedule } from '@mui/icons-material';
import { Container } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserTie } from '@fortawesome/free-solid-svg-icons';
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { useEffect } from 'react';

const LocationDetail = () => {
    const location = useLocation();
    const item = location.state?.item as Location;
    const position: [number, number] = [item.lat, item.lng];
    let branchAddress = `${item.address1} ${item.city}, ${item.state} ${item.zip}`

    const logoIcon = L.icon({
        iconUrl: Logo,
        iconSize: [100, 80],
        iconAnchor: [50, 65],
        popupAnchor: [0, -80],
    })

    const handleLocationShare = async () => {
        // locationShare({ item });
        logEvent(analytics, 'location_share_web', {
            name: 'Location Share',
            description: 'User shared a branch location'
        });
    };

    useEffect(() => {
        console.log(item.lat, item.lng);
    })

    return (
        <Container>
            <div >
                <h1
                    className='itemName' 
                    style={{ marginBlock: 10 }}
                >
                    {item.name}
                </h1>
                <MapContainer 
                    center={position} 
                    zoom={20} 
                    scrollWheelZoom={false}
                    style={{ height: '400px', width: '100%' }}
                >
                    <TileLayer 
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <Marker 
                        position={position}
                        icon={logoIcon}
                    />
                </MapContainer>
            </div>
            <div 
                style={{ position: 'absolute', right: 50, cursor: 'pointer' }}
                onClick={handleLocationShare}
            >
                <IosShare />
            </div>
            <div 
                style={{
                    marginTop: 20,
                    display: 'flex',
                    justifyContent: 'center',
                }}
            >
                <div>
                    <div
                        className='d-flex text-start align-items-center'
                    >
                        <div>
                            <FontAwesomeIcon 
                                icon={faUserTie} 
                                size='2xl'
                                style={{ marginRight: 5 }}
                            />
                        </div>
                        <div className='d-block'>
                            <span className='fw-bold d-block'>Manager</span>
                            <a
                                onClick={() => sendEmail(item.email)}
                                className='d-block'
                                style={{ color: '#1a73e8', textDecoration: 'underline', cursor: 'pointer' }}
                            >
                                {item.manager}
                            </a>
                        </div>
                    </div>
                    <div 
                        className='d-flex text-start align-items-center'
                    >
                        <div style={{ marginRight: 10 }}>
                            <NearMe fontSize='large'/>
                        </div>
                        <div className='d-block'>
                            <span className='fw-bold d-block'>Address</span>
                            <a
                                onClick={() => openMap(branchAddress)}
                                className='d-block'
                                style={{ color: '#1a73e8', textDecoration: 'underline', cursor: 'pointer' }}
                            >
                                {item.address1}
                            </a>
                        </div>
                    </div>
                    <div
                        className='d-flex text-start align-items-center'
                    >
                        <div style={{ marginRight: 10 }}>
                            <PermPhoneMsg fontSize='large'/>
                        </div>
                        <div>
                            <span className='fw-bold d-block'>Phone or Text</span>
                            <a
                                onClick={() => makeCall(formatPhoneLink(item.phone))}
                                className='d-block'
                                style={{ color: '#1a73e8', textDecoration: 'underline', cursor: 'pointer' }}
                            >
                                {formatPhone(item.phone)}
                            </a>
                        </div>
                    </div>
                    <div
                        className='d-flex text-start'
                    >
                        <div style={{ marginRight: 10 }}>
                            <Schedule fontSize='large'/>
                        </div>
                        <div>
                            <span className='fw-bold'>Hours</span>
                            <div 
                                className='d-flex'
                                style={{ flexDirection: 'row', marginLeft: 40, gap: 5 }}
                            >
                                <div>
                                    <span style={{ display: 'block', fontWeight: 'bold'}}>Mon: </span>
                                    <span style={{ display: 'block', fontWeight: 'bold'}}>Tues: </span>
                                    <span style={{ display: 'block', fontWeight: 'bold'}}>Wed: </span>
                                    <span style={{ display: 'block', fontWeight: 'bold'}}>Thurs: </span>
                                    <span style={{ display: 'block', fontWeight: 'bold'}}>Fri: </span>
                                    <span style={{ display: 'block', fontWeight: 'bold'}}>Sat: </span>
                                    <span style={{ display: 'block', fontWeight: 'bold'}}>Sun: </span>
                                </div>
                                <div>
                                    <span className='d-block'>{item.mondayOpen} - {item.mondayClose}</span>
                                    <span className='d-block'>{item.tuesdayOpen} - {item.tuesdayClose}</span>
                                    <span className='d-block'>{item.wednesdayOpen} - {item.wednesdayClose}</span>
                                    <span className='d-block'>{item.thursdayOpen} - {item.thursdayClose}</span>
                                    <span className='d-block'>{item.fridayOpen} - {item.fridayClose}</span>
                                    <span className='d-block'>{item.saturdayOpen} - {item.saturdayClose}</span>
                                    <span className='d-block'>Closed</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    )
};

export default LocationDetail;